<template>
	<!-- :key="$route.fullPath" 解决了路由前缀相同时跳转不刷新 -->
  <router-view :key="$route.fullPath"/>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 强制禁用浏览器的自动滚动恢复，确保刷新后100%在顶部
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }
}
</script>
